'use client';

import Image from 'next/image';
import styles from './Footer.module.css';
import { Facebook, Instagram, Youtube, MessageCircle } from 'lucide-react';

const TikTokIcon = ({ size = 20, className = '' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
    >
        <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
    </svg>
);

const quickLinks = [
    { label: 'Beranda', href: '/' },
    { label: 'Layanan', href: '/layanan' },
    { label: 'Jangkauan', href: '/jangkauan' },
    { label: 'Keunggulan', href: '/keunggulan' },
    { label: 'Galeri', href: '/galeri' },
    { label: 'Artikel', href: '/artikel' },
    { label: 'Loker', href: '/loker' },
    { label: 'Tentang Kami', href: '/tentang-kami' },
];

const serviceLinks = [
    { label: 'Cargo Darat', href: '/layanan/kargo-darat' },
    { label: 'Cargo Laut', href: '/layanan/kargo-laut' },
    { label: 'Cargo Udara', href: '/layanan/kargo-udara' },
    { label: 'Warehousing', href: '/layanan/pergudangan' },
    { label: 'Towing & Gendong', href: '/layanan/towing' },
];

export default function Footer() {
    return (
        <footer className={styles.footer}>
            <div className={styles.footerTop}>
                <div className="container">
                    <div className={styles.footerGrid}>
                        {/* Company Info */}
                        <div className={styles.companyCol}>
                            <div className={styles.footerLogo}>
                                <Image
                                    src="/logo.png"
                                    alt="PT Trans Nusa Pasifik"
                                    width={40}
                                    height={40}
                                    className={styles.footerLogoImage}
                                />
                                <span className={styles.footerLogoText}>
                                    PT Trans <span>Nusa</span> Pasifik
                                </span>
                            </div>
                            <p className={styles.companyDesc}>
                                Agregator logistik terpercaya di Indonesia yang menghubungkan setiap
                                pulau melalui integrasi teknologi dan manajemen yang amanah. Melayani
                                pengiriman cargo darat, laut, udara, hingga layanan towing (derek) 24 jam.
                            </p>
                            <div className={styles.socials}>
                                <a href="https://wa.me/628567874759" target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label="WhatsApp">
                                    <MessageCircle size={20} />
                                </a>
                                <a href="https://www.instagram.com/transnusapasifik?igsh=bGZteTNmeXliYTZ3" target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label="Instagram">
                                    <Instagram size={20} />
                                </a>
                                <a href="https://web.facebook.com/profile.php?id=61582703339239" target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label="Facebook">
                                    <Facebook size={20} />
                                </a>
                                <a href="https://www.youtube.com/@TransNusaPasifik" target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label="YouTube">
                                    <Youtube size={20} />
                                </a>
                                <a href="https://www.tiktok.com/@sipasifik.com?is_from_webapp=1&sender_device=pc" target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label="TikTok">
                                    <TikTokIcon size={20} />
                                </a>
                            </div>
                        </div>

                        {/* Quick Links */}
                        <div>
                            <h3 className={styles.colTitle}>Quick Links</h3>
                            <div className={styles.colLinks}>
                                {quickLinks.map((link) => (
                                    <a key={link.label} href={link.href} className={styles.colLink}>
                                        {link.label}
                                    </a>
                                ))}
                            </div>
                        </div>

                        {/* Services */}
                        <div>
                            <h3 className={styles.colTitle}>Layanan</h3>
                            <div className={styles.colLinks}>
                                {serviceLinks.map((link) => (
                                    <a key={link.label} href={link.href} className={styles.colLink}>
                                        {link.label}
                                    </a>
                                ))}
                            </div>
                        </div>

                        {/* Hubungi Kami */}
                        <div>
                            <h3 className={styles.colTitle}>Hubungi Kami</h3>
                            <div className={styles.colLinks}>
                                <p className={styles.colLink} style={{ alignItems: 'flex-start', lineHeight: 1.5 }}>
                                    <span style={{ fontSize: '1.2rem', marginTop: '-2px' }}>📍</span>
                                    <span>
                                        <strong>Kantor Pusat</strong><br />
                                        Jl. Daan Mogot No.119 Blok A No.12A<br />
                                        Kompleks Aldiron, Jakarta Barat<br />
                                        DKI Jakarta
                                    </span>
                                </p>
                                <p className={styles.colLink} style={{ alignItems: 'flex-start', lineHeight: 1.5 }}>
                                    <span style={{ fontSize: '1.2rem', marginTop: '-2px' }}>📍</span>
                                    <span>
                                        <strong>Kantor Cabang</strong><br />
                                        Jl. Samratulangi 72 A<br />
                                        Manahan-Solo, Jawa Tengah
                                    </span>
                                </p>
                                <a href="https://wa.me/628567874759" className={styles.colLink} target="_blank" rel="noopener noreferrer">
                                    <span style={{ fontSize: '1.2rem' }}>📞</span> 0856-7874-759 (WhatsApp)
                                </a>
                                <a href="tel:02716010777" className={styles.colLink}>
                                    <span style={{ fontSize: '1.2rem' }}>☎️</span> 0271-601-0777 (Kantor)
                                </a>
                                <p className={styles.colLink} style={{ cursor: 'pointer' }} onClick={() => window.location.href = 'mai' + 'lto:' + 'info' + '@' + 'sipasifik.com'}>
                                    <span style={{ fontSize: '1.2rem' }}>✉️</span> info&#64;sipasifik.com
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className={styles.footerBottom}>
                <div className="container">
                    <div className={styles.bottomInner}>
                        <p className={styles.copyright}>
                            © 2026 PT Trans Nusa Pasifik. All rights reserved.
                        </p>
                        <div className={styles.bottomLinks}>
                            <a href="/" className={styles.bottomLink}>Kebijakan Privasi</a>
                            <a href="/" className={styles.bottomLink}>Syarat & Ketentuan</a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}
